import { render, staticRenderFns } from "./formulario_renovacion.vue?vue&type=template&id=74b60fca&scoped=true"
import script from "./formulario_renovacion.vue?vue&type=script&lang=js"
export * from "./formulario_renovacion.vue?vue&type=script&lang=js"
import style0 from "./formulario_renovacion.vue?vue&type=style&index=0&id=74b60fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b60fca",
  null
  
)

export default component.exports